import { render, staticRenderFns } from "./UserPlanView.vue?vue&type=template&id=629e086e"
import script from "./UserPlanView.vue?vue&type=script&lang=js"
export * from "./UserPlanView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports